import type { ObjectGraph } from '@jet/environment/dependencies';
import type {
    ClassicalListItem,
    ClassicalListViewPage,
} from '@jet-app/music-classical/api/types';
import type { Section } from '@jet-app/music-classical/models/section/Section';
import { makeOnListItemClickAction } from '@jet-app/music-classical/action-model/onListItemClickAction';
import { makeTrackCollectionItem } from './track-list';
import { trackLockupLayoutStyle } from '@jet-app/music-classical/models';

export const transformTracks = (
    listViewPage: ClassicalListViewPage,
    objectGraph: ObjectGraph,
): Section<unknown> => {
    const items = (listViewPage.firstPage?.items || []).filter(
        (item) => item.type === 'track',
    );

    return {
        id: `list-view-${listViewPage.title}`,
        sectionKind: 'libraryTracks',
        items: items.map((item: ClassicalListItem) =>
            makeTrackCollectionItem(
                item,
                objectGraph,
                trackLockupLayoutStyle(true),
                'libraryTracks',
                item.workSubheading?.title,
            ),
        ),
        itemKind: items[0]?.type,
        pageMetadata: {
            total: listViewPage?.firstPage?.total ?? 500,
            page: listViewPage?.firstPage?.page,
            next: listViewPage?.firstPage?.next,
        },
    };
};
